var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoyenne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.7 80.2",
    style: {
      enableBackground: "new 0 0 150.7 80.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6,80.2c-0.2,0-0.3,0-0.5,0c-2.3-0.2-4.3-1.7-5.1-3.8l-13.6-35L10.2,62.5c-2.3,2.3-6.1,2.3-8.5,0c-2.3-2.3-2.3-6.1,0-8.5 l27.6-27.6c1.4-1.4,3.5-2,5.5-1.6c2,0.4,3.6,1.8,4.4,3.7l12.4,31.9l28.6-49.1c0.9-1.6,2.6-2.7,4.4-2.9c1.8-0.2,3.7,0.4,5,1.7 l21.2,21.2l29.5-29.5c2.3-2.3,6.1-2.3,8.5,0c2.3,2.3,2.3,6.1,0,8.5L115.2,44c-2.3,2.3-6.1,2.3-8.5,0L86.7,24.1l-31,53.1 C54.7,79,52.7,80.2,50.6,80.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoyenne);
export default __webpack_public_path__ + "static/media/Moyenne.a3af1fb135cc29c2e28b434e0bc03efd.svg";
export { ForwardRef as ReactComponent };